import { Elements } from '@stripe/react-stripe-js';
import { Button, PaymentMethodDlocal, PaymentMethodStripe } from 'components';
import { ButtonBack } from 'components/atoms/Button-back/Button-back';
import { usePaymentMethodForm } from '../hooks/PaymentMethodForm.hook';

interface PaymentMethodFormProps {
  userAuthId?: string;
  handleRefreshCards?: () => void;
  handleShowNewCardForm?: (value: boolean) => void;
  handleError?: (value: string | null) => void;
  isGeneratingLink?: boolean;
  generatePaymentLink?: () => void;
  isPaymentMethodLink: boolean;
  setPopupState?: React.Dispatch<
    React.SetStateAction<{
      isOpen: boolean;
      type: string;
      msg: string;
    }>
  >;
}

export const PaymentMethodForm = ({
  userAuthId,
  isPaymentMethodLink,
  handleRefreshCards,
  handleShowNewCardForm,
  handleError,
  isGeneratingLink,
  generatePaymentLink,
  setPopupState,
}: PaymentMethodFormProps) => {
  const {
    stripeLoad,
    formAddPaymentMethod,
    user,
    changeValueInput,
    handleChangeCheck,
    stripeRef,
    dlocalRef,
    branch,
  } = usePaymentMethodForm({
    userAuthId,
    setPopupState,
    handleRefreshCards,
    handleShowNewCardForm,
    handleError,
    isPaymentMethodLink,
  });

  return (
    <Elements stripe={stripeLoad}>
      <form
        className="add__payment__method__container container__generic"
        onSubmit={formAddPaymentMethod.handleSubmit}
        noValidate
      >
        {!user.formToShow ||
        user.formToShow.toLocaleLowerCase() === 'stripe' ? (
          <PaymentMethodStripe
            id="add-card-number"
            inputNameLabel="Nombre del titular de la tarjeta"
            inputNameControl={'name'}
            handleChangeNameInput={formAddPaymentMethod.handleChange}
            handleBlurNameInput={formAddPaymentMethod.handleBlur}
            touchedNameInput={formAddPaymentMethod.touched.name}
            errorNameInput={formAddPaymentMethod.errors.name}
            valueNameInput={formAddPaymentMethod.values.name}
            checkBoxNameControl={'isPrincipal'}
            checkBoxValue={formAddPaymentMethod.values.isPrincipal}
            handleChangeCheck={handleChangeCheck}
            form={formAddPaymentMethod}
            handleChangeStripeInput={changeValueInput}
            ref={stripeRef}
          />
        ) : (
          <PaymentMethodDlocal
            inputNameLabel="Nombre del titular de la tarjeta"
            inputNameControl="name"
            handleChangeNameInput={formAddPaymentMethod.handleChange}
            handleBlurNameInput={formAddPaymentMethod.handleBlur}
            touchedNameInput={formAddPaymentMethod.touched.name}
            errorNameInput={formAddPaymentMethod.errors.name}
            valueNameInput={formAddPaymentMethod.values.name}
            checkBoxNameControl={'isPrincipal'}
            checkBoxValue={formAddPaymentMethod.values.isPrincipal}
            handleChangeCheck={handleChangeCheck}
            form={formAddPaymentMethod}
            handleChangeDlocalInput={changeValueInput}
            ref={dlocalRef}
            country={branch as 'co' | 'cr'}
          ></PaymentMethodDlocal>
        )}
        <Button
          className="btn__add__payment__method"
          color="primary"
          type="submit"
          size="medium"
          template="primary"
          typeStyle="rounded"
          label="Guardar"
          isDisabled={
            formAddPaymentMethod.isSubmitting ||
            !formAddPaymentMethod.isValid ||
            !formAddPaymentMethod.dirty
          }
          isLoading={formAddPaymentMethod.isSubmitting}
          onClick={formAddPaymentMethod.handleSubmit}
        ></Button>
        {handleShowNewCardForm && (
          <div className="payment-method-footer">
            <p>
              <ButtonBack
                testid="btn_add_credit_card"
                label={'Volver'}
                onClick={() => handleShowNewCardForm(!true)}
                template="primary"
              />
            </p>
            {generatePaymentLink && (
              <p className="payment-method-link" onClick={generatePaymentLink}>
                {isGeneratingLink
                  ? 'Generando link...'
                  : 'Generar link a cliente'}
              </p>
            )}
          </div>
        )}
      </form>
    </Elements>
  );
};
